import * as React from 'react';

import * as styles from './styles.css';

interface ILayoutJournalProps {
  isDesktop: boolean;
}

export const LayoutJournal: React.FC<ILayoutJournalProps & React.PropsWithChildren> = ({ isDesktop, children }) => {
  if (isDesktop) {
    return <div className={styles['desktop-container']}>{children}</div>;
  }

  return <div className={styles['container']}>{children}</div>;
};

LayoutJournal.displayName = 'LayoutJournal';
